import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "callRecordings", "recordingAnalysis", "recordingRetentionDays",
    "safeguardingAnalysis", "emotionalAnalysis", "interactionSummaries", "fullTranscript",
    "safeguardingInclude", "safeguardingExclude", "safeguardingConfig"
  ]

  connect() {
    this.callRecordingsTarget.addEventListener('change', () => this.toggleDisabled())
    this.recordingAnalysisTarget.addEventListener('change', () => this.toggleAnalysisFeatures())
  }

  toggleDisabled() {
    const disabled = !this.callRecordingsTarget.checked;
    this.recordingAnalysisTarget.disabled = disabled;
    this.recordingRetentionDaysTarget.disabled = disabled;

    if (disabled) {
      this.recordingAnalysisTarget.checked = false;
      this.recordingRetentionDaysTarget.value = 0;
    } else {
      // Enable recordingAnalysis when callRecordings is enabled
      this.recordingAnalysisTarget.checked = true;
    }

    // Toggle the other analysis features based on the state of recordingAnalysis
    this.toggleAnalysisFeatures();
  }

  toggleAnalysisFeatures() {
    const enabled = this.recordingAnalysisTarget.checked && !this.recordingAnalysisTarget.disabled;

    this.safeguardingAnalysisTarget.disabled = !enabled;
    this.emotionalAnalysisTarget.disabled = !enabled;
    this.interactionSummariesTarget.disabled = !enabled;
    this.fullTranscriptTarget.disabled = !enabled;

    this.safeguardingAnalysisTarget.checked = enabled;
    this.emotionalAnalysisTarget.checked = enabled;
    this.interactionSummariesTarget.checked = enabled;
    this.fullTranscriptTarget.checked = enabled;

    // Toggle safeguarding config fields
    this.toggleSafeguardingConfig();
  }

  toggleSafeguardingConfig() {
    const enabled = this.safeguardingAnalysisTarget.checked && !this.safeguardingAnalysisTarget.disabled;

    if (this.hasSafeguardingIncludeTarget) {
      this.safeguardingIncludeTarget.disabled = !enabled;
    }
    if (this.hasSafeguardingExcludeTarget) {
      this.safeguardingExcludeTarget.disabled = !enabled;
    }
  }

}
